import DialogActions from "@mui/material/DialogActions";

import LinearLoaderWithTime from "../../../Loaders/LinearLoaderWithTime";
import { MODAL_COMPETITORS_FOOTER_LOADER_SX } from "../constants";

const CompetitorsScrapeProgressBar = ({
  labels = [],
  durationMs,
}) => (
  <DialogActions sx={MODAL_COMPETITORS_FOOTER_LOADER_SX}>
    <LinearLoaderWithTime
      labels={labels}
      time={durationMs}
      sx={{ width: "100%", maxWidth: "none" }}
    />
  </DialogActions>
);

export default CompetitorsScrapeProgressBar;
